'use client'

import { SiteShell } from '@/components/site/site-shell'
import { PageIntro } from '@/components/site/page-intro'
import { RevealText } from '@/components/site/reveal-text'
import { CALENDLY_URL, SOCIAL_LINKS } from '@/content/social'

const links = [
  { name: 'Website', url: 'https://www.elementarycreative.com' },
  { name: 'Work', url: 'https://www.elementarycreative.com/portfolio' },
  { name: 'Services', url: 'https://www.elementarycreative.com/services' },
  ...SOCIAL_LINKS.map((item) => ({ name: item.label, url: item.href })),
  { name: 'Free 30-minute call', url: CALENDLY_URL },
]

export default function ConnectPage() {
  return (
    <SiteShell>
      <div className="flex min-h-[70vh] items-center justify-center px-6 py-24 lg:px-12">
        <div className="mx-auto w-full max-w-md">
          <PageIntro
            eyebrow="Connect"
            title="Elementary Creative"
            description="Links to our work, social channels, and booking."
          />

          <ul className="space-y-3">
            {links.map((link, i) => (
              <RevealText key={link.name} delay={0.05 * i}>
                <li>
                  <a
                    href={link.url}
                    target="_blank"
                    rel="noreferrer"
                    className="group flex items-center justify-between border border-border bg-card/30 px-6 py-4 transition-colors hover:border-accent hover:bg-card/50"
                  >
                    <span className="font-serif text-lg text-foreground group-hover:text-accent">
                      {link.name}
                    </span>
                    <svg
                      className="text-muted-foreground transition-transform group-hover:translate-x-1 group-hover:text-accent"
                      width="20"
                      height="20"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="1.5"
                      aria-hidden
                    >
                      <path d="M7 17L17 7M17 7H7M17 7V17" />
                    </svg>
                  </a>
                </li>
              </RevealText>
            ))}
          </ul>
        </div>
      </div>
    </SiteShell>
  )
}
